import { render, staticRenderFns } from "./Produkt.vue?vue&type=template&id=5f28c9a5&scoped=true&"
import script from "./Produkt.vue?vue&type=script&lang=js&"
export * from "./Produkt.vue?vue&type=script&lang=js&"
import style0 from "./Produkt.vue?vue&type=style&index=0&id=5f28c9a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f28c9a5",
  null
  
)

component.options.__file = "Produkt.vue"
export default component.exports